import { render, staticRenderFns } from "./CompletedQuotes.vue?vue&type=template&id=10f8bc70&"
import script from "./CompletedQuotes.vue?vue&type=script&lang=js&"
export * from "./CompletedQuotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports